
import $ from 'jquery';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Contact } from '../../backend/backendapi';
import TabMain from './ContactEditModal/TabMain.vue';
import TabDetails from './ContactEditModal/TabDetails.vue';
import TabPicture from './ContactEditModal/TabPicture.vue';
import { isValidPhone } from './ContactEditModal/phone';

@Component({
  components: {
    TabDetails,
    TabMain,
    TabPicture,
  },
})
export default class ContactEditModal extends Vue {
  @Prop({ required: true })
  readonly availableSalutations!: string[];

  @Prop({ default: false })
  readonly details!: boolean;

  contact: Contact | null = null;
  activeTab: 'main' | 'details' | 'media' = 'main';

  get canSave(): boolean {
    if (!this.contact) {
      return false;
    }

    const telOk = !this.contact.tel || isValidPhone(this.contact.tel);
    const mobileOk = !this.contact.mobile || isValidPhone(this.contact.mobile);
    return telOk && mobileOk;
  }

  public open(contact: Contact): void {
    this.contact = Contact.fromJS(contact);
    this.activeTab = 'main';
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    this.contact = null;
    $(this.$refs.modal!).modal('hide');
  }
}
